import {
  encodeDelimitedArray,
  decodeDelimitedArray,
  QueryParamConfig,
} from "use-query-params";

/** Uses a comma to delimit entries. e.g. ['a', 'b'] => qp?=a,b */
export const CommaArrayParam: QueryParamConfig<
  (string | null)[] | null | undefined,
  string | (string | null)[] | null | undefined
> = {
  encode: (array) => {
    // remove from query string if value is empty
    if (!array || !array.length) {
      return undefined;
    }

    return encodeDelimitedArray(array, ",");
  },
  decode: (arrayStr) => {
    return decodeDelimitedArray(arrayStr, ",");
  },
};
